import { useSelector } from "react-redux";
import { useEffect } from "react";
import { LanguageEnum } from "../store/slices/app/appTypes";
import { selectLanguage } from "../store/slices/app/appSelector";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const language: LanguageEnum = useSelector(selectLanguage);

  useEffect(() => {
    i18n.changeLanguage(language || LanguageEnum.EN);
    dayjs.locale(language);
  }, [i18n, language]);
};
